module.exports = __webpack_public_path__ + "static/logo_lg-9630c94716d49f0a9e3c9adfde0ccf7a.png";